export enum Pathname {
  LOGIN = "/",
  ScheduleForm = "/schedule/form", // 스케쥴 등록
  ScheduleCheck = "/schedule/check", // 스케쥴 조회
  Dashboard = "/dashboard", // 배송 현황
  User = "/user", // 사용자 관리
  Company = "/company", // 회사 관리
  DeliveryCreate = "/delivery/create", // 물류
  Location = "/location", // 장소
  RoutingService = "/routing-service", // 라우팅서비스
  Setting = "/setting", // 설정
  Report = "/report", // SLA 리포트 (access_sla_report 토글 ON일 때만)
}
